import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownloadCircleFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 15.9998,
			cy: 16.0013,
			r: 13.8333,
			stroke: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.3565 23.1602H10.6665V24.3479H21.3565V23.1602Z",
			fill: "#162395"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3558 8V19.4073L11.6178 16.205L10.7095 17.2647L16.0545 21.8458L21.3995 17.2647L20.4912 16.205L16.7532 19.4073V8H15.3558Z",
			fill: "#162395"
		})
	]
});
export default SvgDownloadCircleFilled;
